import { render, staticRenderFns } from "./fileTree.vue?vue&type=template&id=20784a8e&"
import script from "./fileTree.vue?vue&type=script&lang=js&"
export * from "./fileTree.vue?vue&type=script&lang=js&"
import style0 from "./fileTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports